var CONSTANT = function () {};

CONSTANT.ENV = "DEVELOPMENT";
// CONSTANT.ENV = "PRODUCTION";

CONSTANT.state = "active";

module.exports = CONSTANT;
